import React from 'react'

import { STEP_CONST } from '@constants/demoSaleApplication/constant'
import { DemoSellAlert } from '@zet/common/components/demoSellAlert'
import { Button, Icon, SH3, Stack, colors } from '@zet/design-system'
import { i18n } from '@zet/localization'
import { LeadStatus } from '@zet/utils/Constants'
import { getLoginHash } from '@zet/utils/loginHash'

import KeyBoardWrapper from '@components/keyboardWrapper'

import { useNavigation } from '@hooks/useNavigation'

import { useSetDemoLeadStatus } from '../../../../api/webflow/demoSale/hooks'
import { useDemoSaleApplicationState } from '../../../../store/demoSaleApplicationState'
import { TestBrandApplicationHeader } from '../../../components/testBrancApplicationHeader'

export const ApplicationTracking = () => {
  const { setCurrentState } = useDemoSaleApplicationState((state) => state)
  const { navigate } = useNavigation()
  const hash = getLoginHash()
  const { mutate } = useSetDemoLeadStatus()

  function handlePress() {
    mutate(
      { status: LeadStatus.FULLFILLED },
      {
        onSuccess() {
          setCurrentState(STEP_CONST.LEAD_FULFILLED)
          navigate('LeadApplicationStatus', { hash })
        },
        onError(e) {
          console.log(e)
        },
      }
    )
  }
  return (
    <KeyBoardWrapper
      className="flex-1 bg-white "
      BottomSheet={
        <Button onPress={handlePress} className="my-4/2 mx-3">
          {i18n.t('demoSale.submit')}
        </Button>
      }
    >
      <Stack className="flex-1 bg-white">
        <TestBrandApplicationHeader
          header={i18n.t('demoSale.tracking.header')}
        />
        <DemoSellAlert content={i18n.t('demoSale.tracking.info')} />
        <Stack className="mt-8 items-center justify-center">
          <Icon type="DoneFilled" size={60} color={colors.success[100]} />
        </Stack>
        <Stack className="mt-3 items-center justify-center px-5">
          <SH3 className="text-center">{i18n.t('demoSale.tracking.sh1')}</SH3>
        </Stack>
      </Stack>
    </KeyBoardWrapper>
  )
}
